import ImplicitAuthProvider from './ImplicitAuthProvider'

import jwt from 'jwt-simple'

export default class AutosignTokenAuthProvider implements ImplicitAuthProvider {
  secret: string
  id: string
  email: string

  constructor (secret: string, id: string, email: string) {
    this.secret = secret
    this.id = id
    this.email = email
  }

  redirect (): void {
    throw new Error('Method not implemented.')
  }
  asyncHandle (): Promise<void> {
    throw new Error('Method not implemented.')
  }
  asyncRefresh (): Promise<void> {
    throw new Error('Method not implemented.')
  }
  asyncIsAuthenticated (): Promise<boolean> {
    return Promise.resolve(true)
  }
  asyncLogout (): Promise<void> {
    return Promise.resolve()
  }
  asyncGetToken (): Promise<string> {
    const payload = {
      'https://auth.revas.app/email': this.email,
      'https://auth.revas.app/email_verified': true,
      'https://auth.revas.app/admin': false,
      scope: 'openid profile email',
      audience: ['https://revas.app'],
      iss: 'https://auth.revas.app/',
      sub: `auth0|${this.id}`
    }
    return Promise.resolve(jwt.encode(payload, this.secret))
  }
  asyncGetTokenExpiration (): Promise<Date> {
    throw new Error('Method not implemented.')
  }
}
